import React, { useEffect, useState } from 'react'
import _ from 'lodash';
import { useNavigate, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useAppDispatch } from '../../../../../../hooks/hooks';
import PageLoader from '../../../../../../components/PageLoader';
import AccountTypeComponent from '../components/account-type.component';
import { accountTypes } from '../../../../../../redux/account-types/action';
import { selectAccountTypesQueryItems } from '../../../../../../redux/account-types/selector';
import { selectNetworksListItems } from '../../../../../../redux/dbaas/networks/selector';
import { networks } from '../../../../../../redux/dbaas/networks/action';

const ManagementAccountType = () => {
  const navigate = useNavigate()
  const dispatch = useAppDispatch()
  const parmas: any = useParams()
  const [isLoading, setIsLoading] = useState<boolean>(true)
  const accountTypeQuery = useSelector(selectAccountTypesQueryItems)
  const networkListItems = useSelector(selectNetworksListItems)
  const [isQuery, setIsQuery] = useState<boolean>(false)
  const [
    selectedAccountType,
    setSelectedAccountType
  ] = useState<any>({})


  const fetchAccountTypeById = () => {
    dispatch(accountTypes.query({
      url: `https://identity.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/rms/account-types/fetch-detail`, entity: 'accountTypes', jsonData: {
        Context: {},
        Records: [
          {
            Id: parmas?.id
          }
        ]

      }
    })).then(() => {
      setIsQuery(true)
    }).then(() => {
      setIsLoading(false)
    })
  }

  const handleInnerFormChange: any = (event: any, field: string) => {
    setSelectedAccountType({ ...selectedAccountType, [field]: event });
  }

  useEffect(
    () => {
      dispatch(networks.list({
        url: `https://identity.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/dbaas/networks/list`, entity: 'networks', jsonData: {}
      })).then(() => {
        if (parmas?.id > 0) {
          fetchAccountTypeById()
          setIsLoading(false)
        } else {
          setIsLoading(false)
        }
      })
    },
    []
  )
  useEffect(
    () => {

      if (isQuery) {
        setSelectedAccountType(accountTypeQuery?.result?.items)
      }
    },
    [isQuery]
  )

  const handleFormSubmit = async (event: any) => {
    event.preventDefault();
    const accountCreateItemData = {
      Context: {},
      Records: [{
        Name: selectedAccountType?.Name || '',
        NetworkId: selectedAccountType?.NetworkId || 0,
      }]
    }
    const accountUpdateItemData = {
      Context: {},
      Records: [{
        Id: selectedAccountType?.AccountTypeId || 0,
        Name: selectedAccountType?.Name || '',
        NetworkId: selectedAccountType?.NetworkId || 0,
      }]
    }
    if (parmas?.id > 0) {
      await dispatch(accountTypes.resetAction({ actionType: 'update' }))
      await dispatch(accountTypes.update({
        url: `https://identity.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/rms/account-types`, entity: 'accountTypes', jsonData: {
          Context: {},

          Records: [
            accountCreateItemData
          ]

        }
      }))

    } else {
      await dispatch(accountTypes.resetAction({ actionType: 'create' }))
      await dispatch(accountTypes.create({
        url: `https://identity.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/rms/account-types`, entity: 'accountTypes',
        jsonData:
          accountUpdateItemData
      }))
    }

    back()
  }

  const back = () => {
    navigate('/management/organization/rms/account-types')
  }

  return (
    <>
      {isLoading ? <PageLoader /> :
        <AccountTypeComponent
          networks={networkListItems?.result?.items}
          selectedAccountType={selectedAccountType}
          handleInnerFormChange={handleInnerFormChange}
          back={back}
          handleFormSubmit={handleFormSubmit}
        />
      }
    </>
  )

}

export default ManagementAccountType;